import React, { useState } from 'react';
import { Card, Button, Collapse, Descriptions, Tooltip, Popconfirm, Alert, Row, Col, Statistic, Typography } from 'antd';
import { DeleteOutlined, InfoCircleOutlined } from '@ant-design/icons';

const { Panel } = Collapse;
const { Text } = Typography;

interface BaseResultDisplayProps {
  title?: string;
  data?: any;  // 改为可选
  content?: React.ReactNode;  // 新增content属性
  onDeleteResult?: () => void;
  multiResults?: boolean;
  resultIndex?: number;  // 新增resultIndex属性
  children?: React.ReactNode;
  showRawData?: boolean;
  showDistribution?: boolean;
  fullWidth?: boolean;
}

// 基础结果展示组件，提供通用的卡片布局和删除按钮
const BaseResultDisplay: React.FC<BaseResultDisplayProps> = ({
  title,
  data,
  content,
  onDeleteResult,
  multiResults = false,
  resultIndex,
  children,
  showRawData = true,
  showDistribution = true,
  fullWidth = false,
}) => {
  const [isRawDataVisible, setIsRawDataVisible] = useState(false);

  const renderDataDistribution = () => {
    // This section is temporarily disabled
    return null;
  };

  const renderRawData = () => {
    if (!data) return null;
    return (
      <Panel header="原始数据" key="1">
        <Descriptions bordered size="small" column={1}>
          {Object.entries(data).map(([key, value]) => (
            <Descriptions.Item label={key} key={key}>
              <Text copyable={{ text: String(value) }} style={{ maxWidth: '100%' }}>
                {String(value)}
              </Text>
            </Descriptions.Item>
          ))}
        </Descriptions>
      </Panel>
    );
  };

  return (
    <Card 
      title={title || '结果显示'} // 提供默认标题
      style={{ marginBottom: 16, width: fullWidth ? '100%' : undefined, maxWidth: '100%' }}
      bodyStyle={{ padding: 16, overflow: 'auto', width: '100%' }}
      extra={
        onDeleteResult && (
          <Tooltip title={multiResults ? "关闭此项结果" : "删除结果"}>
            <Popconfirm
              title="确定要删除吗？"
              onConfirm={onDeleteResult}
              okText="是"
              cancelText="否"
            >
              <Button icon={<DeleteOutlined />} type="text" danger />
            </Popconfirm>
          </Tooltip>
        )
      }
    >
      {content || children}
      {(showRawData || showDistribution) && data && (
        <Collapse ghost style={{ marginTop: 16 }}>
          {showRawData && renderRawData()}
          {showDistribution && renderDataDistribution()}
        </Collapse>
      )}
    </Card>
  );
};

export default BaseResultDisplay;